import { Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
//Shared Component
import Navbar from './Components/User/Navbar/Navbar';
//Pages
import Product from './Components/User/Pages/Product/Product';
import Pricing from './Components/User/Pages/Pricing/Pricing';
import Resources from './Components/User/Pages/Resources/Resources';
import Contact from './Components/User/Pages/Contact/Contact';
import Home from './Components/User/Pages/Home/Home';
import Login from './Components/User/Login/Login';
import Signup from './Components/User/SignUp/SignUp';
// import AboutUs from './Components/User/AboutUs/AboutUs';
import Demo from './Components/User/Demo/Demo';
import Methodology from './Components/User/Pages/Methodology/Methodology';
import About from './Components/User/Pages/About/About';

function App() {
  const location = useLocation();
  const hideNavbarRoutes = ['/login', '/signup'];
  return (
    <>
      {!hideNavbarRoutes.includes(location.pathname) && <Navbar />}
      <Routes>
        <Route path='/' element={<Home />} ></Route>
        <Route path='/product' element={<Product />} ></Route>
        <Route path='/methodology' element={<><Demo /><Methodology /></>} ></Route>
        <Route path='/pricing' element={<><Demo /><Pricing /></>} ></Route>
        <Route path='/about' element={<><About /></>} ></Route>
        <Route path='/resources' element={<Resources />} ></Route>
        <Route path='/contact' element={<><Demo /><Contact /></>} ></Route>
        <Route path='/login' element={<Login />} ></Route>
        <Route path='/signup' element={<Signup />} ></Route>
      </Routes>
    </>
  );
}

export default App;
